import { get } from 'lodash';

const defaultPrefix = 'appConfig.config.';

// TODO: Set false by default before deploying to prod
export const isChargerTelemetryAvailable = (state, prefix = defaultPrefix) => get(state, `${prefix}chargerDetails.telemetry.show`, false);

export const selectConfigurationNodeAvailability = (state, prefix = defaultPrefix) =>
  get(state, `${prefix}chargerDetails.configuration.show`, false);

export const isLoadNodeInDecorativeMode = (state, prefix = defaultPrefix) => get(state, `${prefix}plaza.loadNode.decorativeMode`, false);

export const lockInterval = (state, prefix = defaultPrefix) => get(state, `${prefix}lockInterval`, 60) * 1000;

export const showChargerTasks = (state, prefix = defaultPrefix) => get(state, `${prefix}showChargerTasks`);

// Home
export const isHomePageAvailable = (state, prefix = defaultPrefix) => get(state, `${prefix}home.available`, true);
export const selectProductTypeFilter = (state) => get(state, `${defaultPrefix}home.showProductTypeFilter`, false);

export const selectShowFullEnergy = (state) => get(state, `${defaultPrefix}home.showFullEnergy`, false);

// Dashboard
export const isDashboardAvailable = (state, prefix = defaultPrefix) => get(state, `${prefix}dashboard.available`, true);

// Delivered Energy Report
export const isDeliveredEnergyReportAvailable = (state, prefix = defaultPrefix) =>
  get(state, `${prefix}reports.deliveredEnergy.available`, true);

// Energy Mix Report
export const isEnergyMixReportAvailable = (state, prefix = defaultPrefix) => get(state, `${prefix}reports.energyMix.available`, true);

// Charging Session Report
export const isChargingSessionReportAvailable = (state, prefix = defaultPrefix) =>
  get(state, `${prefix}reports.chargingSession.available`, true);

export const isChargingSessionReportFirstLevelGraphAvailable = (state, prefix = defaultPrefix) =>
  get(state, `${prefix}reports.chargingSession.firstLevelGraph.available`, true);

export const isChargingSessionReportFirstLevelTableAvailable = (state, prefix = defaultPrefix) =>
  get(state, `${prefix}reports.chargingSession.firstLevelTable.available`, true);

export const isChargingSessionReportSecondLevelGraphAvailable = (state, prefix = defaultPrefix) =>
  get(state, `${prefix}reports.chargingSession.secondLevelGraph.available`, true);

export const isChargingSessionReportSecondLevelTableAvailable = (state, prefix = defaultPrefix) =>
  get(state, `${prefix}reports.chargingSession.secondLevelTable.available`, true);

// Faults Report
export const isFaultsReportAvailable = (state, prefix = defaultPrefix) => get(state, `${prefix}reports.faults.available`, true);

export const isFaultsReportFirstLevelGraphAvailable = (state, prefix = defaultPrefix) =>
  get(state, `${prefix}reports.faults.firstLevelGraph.available`, true);

export const isFaultsReportFirstLevelTableAvailable = (state, prefix = defaultPrefix) =>
  get(state, `${prefix}reports.faults.firstLevelTable.available`, true);

export const isFaultsReportSecondLevelGraphAvailable = (state, prefix = defaultPrefix) =>
  get(state, `${prefix}reports.faults.secondLevelGraph.available`, true);

export const isFaultsReportSecondLevelTableAvailable = (state, prefix = defaultPrefix) =>
  get(state, `${prefix}reports.faults.secondLevelTable.available`, true);

// FW Versions Report
export const isFWVersionsReportAvailable = (state, prefix = defaultPrefix) => get(state, `${prefix}reports.fwVersions.available`, true);

// Power Monitoring Report
export const isPowerMonitoringReportAvailable = (state, prefix = defaultPrefix) => false; // get(state, `${prefix}reports.powerMonitoring.available`, true)

// Plaza Report
export const isPlazaReportAvailable = (state, prefix = defaultPrefix) => get(state, `${prefix}reports.plazaReport.available`, true);

// View charger page, the sessions tab
export const getExportChargerSessionsLimit = (state) => get(state, 'appConfig.config.export.chargerSessions.limit', 5000);

// View charger page, the activities tab
export const getExportActivitiesLimit = (state) => get(state, 'appConfig.config.export.activities.limit', 5000);

// Charger list page
export const getExportChargersLimit = (state) => get(state, 'appConfig.config.export.chargers.limit', 5000);

// Admin tools, each page
export const getExportDictionariesLimit = (state) => get(state, 'appConfig.config.export.dictionaries.limit', 5000);

// View charger page, the faults tab
export const getExportFailuresLimit = (state) => get(state, 'appConfig.config.export.failures.limit', 5000);

// FW Update list page
export const getExportFirmwareUpdatesLimit = (state) => get(state, 'appConfig.config.export.firmwareUpdates.limit', 5000);

// Configuration Update list page
export const getExportConfigUpdatesLimit = (state) => get(state, 'appConfig.config.export.configUpdate.limit', 5000);

// Admin tools, user list page
export const getExportUsersLimit = (state) => get(state, 'appConfig.config.export.users.limit', 5000);

export const getExportUserRolesLimit = (state) => get(state, 'appConfig.config.export.userRoles.limit', 5000);

export const getExportChargingSessionMetricsLimit = (state) => get(state, 'appConfig.config.export.chargingSessionMetrics.limit', 5000);

// Faults report page
export const getExportFaultsLimit = (state) => get(state, 'appConfig.config.export.faults.limit', 5000);

export const getExportFirmwareVersionChargersLimit = (state) => get(state, 'appConfig.config.export.firmwareVersionChargers.limit', 5000);

// Charging session report page
export const getExportSessionsLimit = (state) => get(state, 'appConfig.config.export.sessions.limit', 5000);

// Plaza page
export const getGreengrassVisibility = (state) => get(state, 'appConfig.config.plaza.greengrass.show', false);

// Telemetry version of Power Monitoring
export const getPowerMonitoringVersion = (state, prefix = defaultPrefix) =>
  get(state, `${prefix}reports.powerMonitoring.telemetryVersion`, false);

export const getRealTimeLoadRangeRequest = (state) => get(state, `${defaultPrefix}plaza.rtLoad.telemetry.range`, 24);

export const getRealTimePowerRangeRequest = (state) => get(state, `${defaultPrefix}plaza.rtPower.telemetry.range`, 24);

// View charger page, the sessions tab
export const getMonitoringDynamicDataInterval = (state) => get(state, `${defaultPrefix}plazaMonitoringDataInterval`, 30000);

// View charger page, the sessions tab
export const getMonitoringDynamicDataDemoInterval = (state) => get(state, `${defaultPrefix}plazaMonitoringDemoDataInterval`, 3000);

export const getMonitoringEventsInterval = (state) => get(state, `${defaultPrefix}plazaMonitoringEventsInterval`, 30000);

export const getMonitoringEventsDemoInterval = (state) => get(state, `${defaultPrefix}plazaMonitoringDemoEventsInterval`, 3000);

export const showPlazaMonitorTableView = (state) => get(state, `${defaultPrefix}plaza.showTableView`, true);

export const selectAppConfig = (state) => get(state, 'appConfig.config', {});

export const selectAppClearConfig = (state) => get(state, 'appConfig.clearConfig', {});
export const selectPlazaAvailabilityMode = (state) => get(state, `${defaultPrefix}plazaAvailabilityMode`);
export const selectTechInfo = (state) => get(state, `${defaultPrefix}chargerDetails.techInfo.hide`);
export const selectUiLabels = (state) => get(state, `${defaultPrefix}ui_labels`);
export const selectShowTechnicalInfoFields = (state) => get(state, `${defaultPrefix}showTechnicalInfoFields`, false);

export const selectMeterWiring = (state) => get(state, `${defaultPrefix}meter_wiring`, null);
